import { render } from "./Banner.vue?vue&type=template&id=3b35d43d&scoped=true"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"

import "./Banner.vue?vue&type=style&index=0&id=3b35d43d&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3b35d43d"

export default script